import React from 'react';
import { TrialBanner } from './TrialBanner';

interface InsightLayoutProps {
  children: React.ReactNode;
  /** Trial expiration date from tenant config */
  trialExpirationDate?: Date | string;
  /** Whether to show the trial banner */
  showTrialBanner?: boolean;
}

/**
 * Layout wrapper for all Insight module views.
 * Includes the trial banner and any other Insight-specific UI elements.
 */
export const InsightLayout: React.FC<InsightLayoutProps> = ({
  children,
  trialExpirationDate,
  showTrialBanner = true,
}) => {
  // TODO: In the future, read trial info from tenant/customer configuration
  // For now, use default expiration date of 30/Jan/2026
  const defaultExpirationDate = new Date('2026-01-30T00:00:00Z');

  const handleUpgradeClick = () => {
    // Open upgrade/contact sales page
    window.open('https://transitxchange.cloud/contact', '_blank');
  };

  return (
    <div className="flex flex-col h-full w-full">
      {/* Trial Banner - Only shown if showTrialBanner is true */}
      {showTrialBanner && (
        <TrialBanner
          expirationDate={trialExpirationDate || defaultExpirationDate}
          onUpgradeClick={handleUpgradeClick}
        />
      )}

      {/* Main Content */}
      <div className="flex-1 overflow-auto">
        {children}
      </div>
    </div>
  );
};

export default InsightLayout;




